module.exports = __webpack_public_path__ + "static/steve-carter-3d8a8ed5e419589935d951d0ed0d2973.png";